import { useErrorHandlingSlice } from 'app/error/slice';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import useApi from 'services/mavapi/useApi';
import {
  FinanceService,
  FinancialReportResponse,
  FinancialSummary,
} from 'services/openapi';

const useFinancialApi = () => {
  const [loading, setLoading] = useState(false);
  const {
    financeGetFinancialReportList,
    financeGetFinancialSummary,
    financeExportFinancialReportList,
  } = FinanceService;
  const [, setError] = useState<unknown | null>();
  const { error: apiError, handleRequest } = useApi();
  const [financialReportList, setFinancialReportList] =
    useState<FinancialReportResponse>();
  const [financialSummaryData, setFinancialSummaryData] =
    useState<FinancialSummary>();
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const { actions } = useErrorHandlingSlice();

  const fetchFinancialSummary = () => {
    setLoading(true);
    handleRequest(financeGetFinancialSummary())
      .then(res => {
        if (res) {
          setFinancialSummaryData(res);
        }
        setLoading(false);
      })
      .catch(() => {
        setError(apiError);
        setLoading(false);
      });
  };

  const fetchFinancialReportList = (
    page: number = 1,
    limit: number = 10,
    searchInput?: string,
    paymentStatus?: string,
    payerType?: string,
  ) => {
    setLoading(true);
    let pageNumCall = page ? Math.floor(page / (limit || 10)) + 1 : 1;
    handleRequest(
      financeGetFinancialReportList(
        pageNumCall,
        limit,
        searchInput,
        paymentStatus,
        payerType,
      ),
    )
      .then(res => {
        if (res) {
          setFinancialReportList(res);
        }
        setLoading(false);
      })
      .catch(() => {
        setError(apiError);
        setLoading(false);
      });
  };
  const handleDownloadFinancial = (
    searchInput?: string,
    paymentStatus?: string,
    payerType?: string,
  ) => {
    setDownloadLoading(true);
    return new Promise((resolve, reject) => {
      handleRequest(
        financeExportFinancialReportList(searchInput, paymentStatus, payerType),
      )
        .then(res => {
          dispatch(
            actions.dispatchToast({
              errorTxt: 'Downloaded Successfully',
              show: true,
              errorType: 'success',
            }),
          );
          resolve(res);
          setDownloadLoading(false);
          setLoading(false);
        })
        .catch(() => {
          setDownloadLoading(false);
          reject(apiError);
          setLoading(false);
        });
    });
  };
  return {
    fetchFinancialSummary,
    fetchFinancialReportList,
    financialReportList,
    financialSummaryData,
    loading,
    handleDownloadFinancial,
    downloadLoading,
  };
};
export default useFinancialApi;
